import Rest from './Rest';
const API_BASE_URL = process.env.REACT_APP_API_URL;
export class SampleRequestService {

  static async getSampleRequestList(pagination) {
    try {

      return await Rest.post(`/request-sample-list`, pagination)
        .then((response) => response.data);
    } catch (error) {
      console.error('Error fetching request list:', error);
      throw error;
    }
  }

  //sample types
  static async getAllActiveSamplesList() {
    try {

      return await Rest.get(`/sample-list`)
        .then((response) => response.data);
    } catch (error) {
      console.error('Error fetching active sample list:', error);
      throw error;
    }
  }
  static async getSampleRequestDetails(requestId) {
    try {
      const response = await Rest.post(`${API_BASE_URL}/view-sample-request`,{ request_id: requestId });
      return response.data;
    } catch (error) {
      console.error('Error fetching sample request details:', error);
      throw error;
    }
  }
  // change this endpoint when received 
  static async exportSampleRequestList(filters) {

    return Rest.post(`${API_BASE_URL}/export-request-samples`, filters)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error('Error exporting sample requests list:', error);
        throw error;
      });
  }

  static async cancelSampleRequest(payload) {

    return Rest.post(`${API_BASE_URL}/cancel-request`, payload)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error('Error canceling sample request :', error);
        throw error;
      });
  }

  static async collectSampleType(payload) {

    return Rest.post(`${API_BASE_URL}/collected-sample`, payload)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error('Error collecting sample type :', error);
        throw error;
      });
  }

  static async deleteSampleRequest(request_id) {

    return Rest.post(`${API_BASE_URL}/delete-sample-request`, { request_id })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error('Error deleting sample request :', error);
        throw error;
      });
  }

  static async duplicateSampleRequest(request_id) {

    return Rest.post(`${API_BASE_URL}/duplicate-sample-request`, { request_id })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error('Error duplicating sample request :', error);
        throw error;
      });
  }

  static async exportSampleRequest(payload) {

    return Rest.post(`${API_BASE_URL}/export-view-sample`,  payload )
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error('Error duplicating sample request :', error);
        throw error;
      });
  }
  // Get total widget count for sample request listing
  static async getTotalWidgetCount(filters) {

    return Rest.post(`${API_BASE_URL}/widget-count`, filters)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error('Error getting Total Widget Count:', error);
        throw error;
      });
  }

  // Get list of sample pickup based on sample count
  static async getPickupListDetails(sample_count) {
 
    return Rest.post(`${API_BASE_URL}/sample-pickup`, sample_count)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error('Error getting sample pickup list:', error);
        throw error;
      });
  }
  // Get pickup details for sample request
  static async getPickupDetails(request_id) {
 
    return Rest.post(`${API_BASE_URL}/pick-up-details`, {request_id})
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error('Error getting pickup details:', error);
        throw error;
      });
  }
  // Update  pickup details for sample request
  static async updatePickupDetails( payload) {

    return Rest.post(`${API_BASE_URL}/update-pickup`, payload)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error('Error getting pickup details:', error);
        throw error;
      });
  }


  
  // Get pickup time schedule for sample request
  static async getPickupTimeSchedule(request) {
    
        return Rest.post(`${API_BASE_URL}/sample-pickup-schedule`, request)
          .then(response => {
            return response.data;
          })
          .catch(error => {
            console.error('Error getting pickup time schedule:', error);
            throw error;
          });
      }

  // Get pickup time schedule for Selected Date 
  static async getPickupTimeScheduleForSelectedDate(request) {
    
    return Rest.post(`${API_BASE_URL}/time-schedule`, request)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error('Error getting pickup time schedule for selected date:', error);
        throw error;
      });
  }


    //  Fetch compensation and appointment duration details for lab
    static async getCompensationAndAppointmentDuationDetails(lab_id) {
    
      return Rest.post(`${API_BASE_URL}/duration-compensation`, lab_id)
        .then(response => {
          return response.data;
        })
        .catch(error => {
          console.error('Error getting Compensation And Appointment Duation Details', error);
          throw error;
        });
    }

    static async addDurationCompensationAppointment(addAppointments) {
      try {
        
        const response = await Rest.post(`${API_BASE_URL}/add-duration-compensation`, addAppointments);
        
         
        return response.data;
      } catch (error) {
        console.error('Error addimg Duration Compensation Appointment', error);
        throw error;  
      }
    }
    static async updateDurationCompensationAppointment(updatedAppointments) {
      try {
        
        const response = await Rest.post(`${API_BASE_URL}/update-duration-compensation`, updatedAppointments);
        
         
        return response.data;
      } catch (error) {
        console.error('Error updating Duration Compensation Appointment', error);
        throw error;  
      }
    }
    static async notifyPickup(payload) {
      try {
        
        const response = await Rest.post(`${API_BASE_URL}/notify-pickup-up`, payload);
        
         
        return response.data;
      } catch (error) {
        console.error('Error notifying pickup to Requestor', error);
        throw error;  
      }
    }


    static async fetchSampleDetails(payload) {
      try {
        
        const response = await Rest.post(`${API_BASE_URL}/fetch-sample-details`, payload); 
        return response.data;
      } catch (error) {
        console.error('Error fetching sample details.', error);
        throw error;  
      }
    }
    static async fetchInviteDonorDetails(payload) {
      try {
        
        const response = await Rest.post(`${API_BASE_URL}/fetch-invite-donor-details`, payload); 
        return response.data;
      } catch (error) {
        console.error('Error fetching invite donor details.', error);
        throw error;  
      }
    }
    static async unassignedDonors(payload) {
      try { 
        const response = await Rest.post(`${API_BASE_URL}/unassigned-donors`, payload); 
        return response.data;
      } catch (error) {
        console.error('Error assigning unassigned donor', error);
        throw error;  
      }
    }


    static async inviteSpecificDonor(payload) {
      try { 
        const response = await Rest.post(`${API_BASE_URL}/invite-specific-donor`, payload); 
        return response.data;
      } catch (error) {
        console.error('Error inviting specific donor', error);
        throw error;  
      }
    }

    
    static async inviteQualifiedDonor(payload) {
      try { 
        const response = await Rest.post(`${API_BASE_URL}/invite-qualified-donors`, payload); 
        return response.data;
      } catch (error) {
        console.error('Error inviting qualified donor', error);
        throw error;  
      }
    }
 static async downloadHealthData(requestId, donorId) {
  try {
    const payload = {
      request_id: requestId,
      donor_id: donorId,
    };

    const response = await Rest.post(
      `${API_BASE_URL}/export-job-donor-hdata`,
      payload
    );
    return response.data;
    // const data = response.data; //  unwrap

    // if (data.success) {
    //   const downloadUrl = data.download_url;

    //   const link = document.createElement("a");
    //   link.href = downloadUrl;

    //   // optional filename
    //   const filename =
    //     downloadUrl.split("/").pop() ||
    //     `healthdata_${requestId}_${donorId}.pdf`;
    //   link.setAttribute("download", filename);

    //   document.body.appendChild(link);
    //   link.click();
    //   document.body.removeChild(link);

    //   return { success: true, message: data.message };
    // } else {
    //   return { success: false, message: data.message };
    // }
  } catch (error) {
    console.error("Error downloading donor health data:", error);
    throw error;
  }
}
static async downloadHealthAllData(requestId, donorId) {
  try {
    const payload = {
      request_id: requestId,
      donor_id: donorId,
    };

    const response = await Rest.post(
      `${API_BASE_URL}/download-all-job-donor-health-data`,
      payload
    );
    return response.data;
     
  } catch (error) {
    console.error("Error downloading donor health data:", error);
    throw error;
  }
}
}

export function getStatusLabel(statusId, userType) {
  const status = statusTypes.find((item) => item.id === statusId);

  if (!status) return '-';

  // Modify label based on userType and statusId
  if (statusId === 1) {
    if (userType === 'admin') {
      return 'Open';
    } else if (userType === 'requestor') {
      return 'Submitted';
    }
  }
  return status.label;
}

export function getLabStatusLabel(labStatusId) {

  const labStatus = labStatusTypes.find((item) => item.id === labStatusId);
  return labStatus ? labStatus.label : '-';
}

export function getStatuses() {
  return Promise.resolve(statusTypes);
}
export function getLabStatuses() {
  return Promise.resolve(labStatusTypes);
}


// admin [1, 4, 5, 6, 7, 8] requestor  [ 0 , 1, 2 ]
export const statusTypes = [
  { id: 0, label: 'Draft', value: 0 },
  { id: 1, label: 'Submitted', value: 1 },  //admin show open
  { id: 2, label: 'Completed', value: 2 }, //requestor
  { id: 3, label: 'Deleted', value: 3 },
  { id: 4, label: 'Cancelled', value: 4 },
  { id: 5, label: 'Partially Booked', value: 5 },
  { id: 6, label: 'Fully Booked', value: 6 },
  { id: 7, label: 'Collected', value: 7 },
  { id: 8, label: 'Picked Up', value: 8 },
];

export const labStatusTypes = [
  { id: 1, label: 'Open', value: 1 },
  { id: 2, label: 'Ready for Pickup', value: 2 },
  { id: 3, label: 'Picked Up', value: 3 },
  { id: 4, label: 'Cancelled', value: 4 },
];